import { env } from '@/env';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Badge, Card } from 'antd';
import { useEffect, useState } from 'react';

export const DebugPage = () => {
  const [isConnected, setIsConnected] = useState<boolean | null>(null);

  useEffect(() => {
    const checkConnection = async () => {
      try {
        const response = await fetch(`${env().VITE_API_URL}/health`, {
          method: 'HEAD',
          headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
          },
        });
        setIsConnected(response.ok);
      } catch (_error) {
        setIsConnected(false);
      }
    };

    checkConnection();
    const interval = setInterval(checkConnection, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="px-8 py-8">
      <div className="space-y-6">
        <Card title="API Configuration" className="w-full">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">API Connection Status:</h3>
              <div className="flex items-center gap-2">
                {isConnected === null ? (
                  <Badge status="processing" text="Checking..." />
                ) : isConnected ? (
                  <div className="flex items-center gap-2 text-green-500">
                    <CheckCircleOutlined className="h-5 w-5" />
                    <span className="text-sm font-medium">Connected</span>
                  </div>
                ) : (
                  <div className="flex items-center gap-2 text-red-500">
                    <CloseCircleOutlined className="h-5 w-5" />
                    <span className="text-sm font-medium">Not Connected</span>
                  </div>
                )}
              </div>
            </div>

            <div>
              <h3 className="text-sm font-medium mb-2">
                Current Configuration:
              </h3>
              <pre className="bg-muted p-4 rounded-lg overflow-auto">
                {JSON.stringify({ ...env() }, null, 2)}
              </pre>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
